import styles from './MenuIcon.module.css';

interface MenuIconProps {
    active?: boolean;
    instantActive?: boolean;
}
export const MenuIcon = ({ active, instantActive }: MenuIconProps) => (
    <div
        className={`menuIcon ${styles.menuIcon} ${active ? styles.active : ''} ${
            instantActive ? styles.instantActive : ''
        }`}
    >
        <div></div>
    </div>
);
